import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function SiteLoader() {
  const [done, setDone] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let v = 0;
    const id = setInterval(() => {
      v += Math.random() * 14 + 4;
      if (v >= 100) {
        v = 100;
        clearInterval(id);
        setTimeout(() => setDone(true), 350);
      }
      setProgress(Math.min(100, Math.floor(v)));
    }, 110);
    return () => clearInterval(id);
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="site-loader"
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#080808]"
          exit={{ y: "-100%", transition: { duration: 0.9, ease: [0.7, 0, 0.2, 1] } }}
        >
          <div className="absolute inset-0 blueprint-grid opacity-30" />
          <div className="absolute -top-40 left-1/2 -translate-x-1/2 h-[500px] w-[500px] orange-glow" />

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="relative z-10 flex flex-col items-center gap-8"
          >
            <motion.img
              src="/hoflich-logo.png"
              alt="Hoflich"
              className="h-32 md:h-40 w-auto"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 1, ease: "easeOut" }}
            />
            <p className="eyebrow">Building Your Own Land · Simplified</p>

            <div className="w-[260px] sm:w-[360px]">
              <div className="h-[2px] w-full bg-white/10 overflow-hidden">
                <motion.div
                  className="h-full bg-[#C96A2B]"
                  initial={{ width: 0 }}
                  animate={{ width: `${progress}%` }}
                  transition={{ ease: "linear", duration: 0.15 }}
                />
              </div>
              <div className="mt-3 flex justify-between text-[11px] tracking-[0.3em] text-white/50">
                <span>LOADING</span>
                <span data-testid="loader-progress">{progress}%</span>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
